import React from 'react';
import {
  BrowserRouter, Route, Routes,
} from 'react-router-dom';

import Oppskrifter from './pages/Oppskrifter';
import Oppskrift from './pages/Oppskrift';
import NewOppskrift from './pages/NewOppskrift';
import {Stack, ChakraProvider} from '@chakra-ui/react';
import ProtectedRoute from 'pages/signIn/protectedRoute';
import SignIn from 'pages/signIn/signIn';


const App:React.FC = () => (
  <ChakraProvider>
    <BrowserRouter>
      <Stack p="2rem" spacing={3}>
        <Routes>
          <Route path="/" element={<Oppskrifter />} />
          <Route path="/oppskrift/:oppskriftId" element={<Oppskrift />} />
          {/* Registrering er stengt i Firebase Auth; kontoer opprettes i konsollen. */}
          <Route path="/signIn" element={<SignIn />} />
          {/* Lesing er åpent for alle; bare redigering krever innlogging. */}
          <Route path="/edit" element={<ProtectedRoute />}>
            <Route index element={<NewOppskrift />} />
            <Route path=":oppskriftId" element={<NewOppskrift />} />
          </Route>
        </Routes>
      </Stack>
    </BrowserRouter>
  </ChakraProvider>
);
export default App;

